import { AccountantActionTypes } from "./actionTypes"


export const getAccountants = (payload) => {
    return {
        type: AccountantActionTypes.ACCOUNTANT_LIST_GET,
        payload: payload
    }
}

export const getAccountantsSuccessful = (payload) => {
    return {
        type: AccountantActionTypes.ACCOUNTANT_LIST_GET_SUCCESSFUL,
        payload: payload
    }
}

export const getAccountantsError = (payload) => {
    return {
        type: AccountantActionTypes.ACCOUNTANT_LIST_GET_ERROR,
        payload,
    }
}

export const setAccountantQuery = (payload) => {
    return {
        type: AccountantActionTypes.SET_ACCOUNTANT_QUERY,
        payload
    }
}

export const resetAccountantQuery = () => {
    return {
        type: AccountantActionTypes.RESET_ACCOUNTANT_QUERY
    }
}
